import React from 'react';
import {WidgetProps} from '../types';

const ChoiceExpandedWidget: React.FC<WidgetProps> = ({}) => {
    return null;
};

export default ChoiceExpandedWidget;
